export default function Principles() {
  return (
    <section className="w-full py-16 md:py-24 lg:py-32 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <p className="text-xs md:text-sm tracking-wider uppercase text-secondary-600 font-medium mb-4 md:mb-6">
          Principles
        </p>
        <div>
          <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-light text-primary-700 leading-snug">
            Usability and stability
            <br />
            through continuous
            <br />
            <span className="font-medium text-primary-800">innovation and refinement</span>
          </h2>

          <div className="mt-6 md:mt-10 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8">
            <div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 mb-2">
                User-Centered Design
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                Every technical decision is evaluated through the lens of the end-user experience.
                Usability is not an afterthought — it is a core engineering constraint that shapes
                architecture, performance targets, and interface design from day one.
              </p>
            </div>
            <div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 mb-2">
                Technical Excellence
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                We actively explore new technologies and evolve our internal processes to maintain high
                technical standards. Continuous improvement of development workflows and adoption of
                up-to-date engineering practices are integral to how we operate.
              </p>
            </div>
            <div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 mb-2">
                Long-Term Thinking
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                We build systems with the future in mind. Clean architecture, comprehensive testing,
                and thoughtful abstraction ensure that our solutions remain adaptable, maintainable,
                and reliable as requirements evolve over time.
              </p>
            </div>
            <div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 mb-2">
                Continuous Innovation
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                Innovation is embedded in our engineering culture. We constantly refine our approach,
                integrate emerging best practices, and push the boundaries of what is possible within
                the iOS platform ecosystem to deliver future-ready solutions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}